import styled from 'styled-components';

export const CompanyBrand = styled.div`
  display: flex;
  justify-content: space-between;

  .avatar {
    display: flex;
    align-items: center;

    p {
      margin-left: 12px;
      font-size: 14px;
      font-weight: 500;
    }
  }
`;

export const OpportunityName = styled.h1`
  font-size: 32px;
  margin: 12px 0 24px 0;
  color: ${props => props.theme.colors.primary};
`;